export default __webpack_public_path__ + "static/media/Watchvideo.cd4b9fbd.svg";